module.exports = __webpack_public_path__ + "static/media/cv.78eb44af.jpeg";